import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

export default function PrivacyPolicy() {
  const [hovered, setHovered] = useState("privacypolicy");

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Privacy Policy",
      active: hovered === "t&c" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("privacypolicy"),
      onMouseLeave: () => setHovered("privacypolicy"),
    },
  ];

  const sections = [
    {
      subTitle: "1. Introduction",
      paragraphs: [
        "ViviMED (“we,” “our,” “us”) is committed to protecting your privacy and safeguarding your personal and medical information. This Privacy Policy explains how we collect, use, share, and retain information when you use our websites, mobile apps, and healthcare services.",
        "By using ViviMED’s services, you consent to the practices described in this policy.",
      ],
    },
    {
      subTitle: "2. Information We Collect",
      nestedList: [
        {
          heading: "A. Personal Information",
          items: [
            "Full name, date of birth, gender",
            "Contact information (phone number, email, physical address)",
            "National identification details where required for verification",
          ],
        },
        {
          heading: "B. Medical Information",
          items: [
            "Full name, date of birth, gender",
            "Contact information (phone number, email, physical address)",
            "National identification details where required for verification",
            "Healthcare conditions and/or unique medical identifiers",
          ],
        },
        {
          heading: "C. Emergency Contact Information",
          items: [
            "Full name, date of birth, gender",
            "Contact information (phone number, email, physical address)",
            "National identification details where required for verification",
          ],
        },
      ],
    },
    {
      subTitle: "3. How We Collect Information",
      list: [
        "Online registrations/forms (website or app)",
        "In-person or virtual consultations",
        "Communications with case coordinators, nurses, and physicians",
        "Payment processing systems",
        "Use of our mobile or web platforms",
      ],
    },
    {
      subTitle: "4. Scope of Services",
      paragraphs: [
        `"ViviMED" refers to our company, its staff, and authorized representatives.`,
        `"Sponsor" means the person, usually a family member living abroad, who sends and funds care for a patient in Cameroon.`,
        `"Patient" refers to the individual receiving care through ViviMED.`,
        `"Care Team" means the involved physicians, nurses, and coordination delivering services.`,
        `"Services" include at-home visits, virtual consultations, wellness checks, case coordination, and related offerings provided by ViviMED.`,
        `We do not provide emergency hospital care, surgery, or services beyond the scope of our licensed staff’s expertise.`,
      ],
    },
    {
      subTitle: "5. Medical Disclaimer",
      paragraphs: [
        `"ViviMED" refers to our company, its staff, and authorized representatives.`,
        `"Sponsor" means the person, usually a family member living abroad, who sends and funds care for a patient in Cameroon.`,
        `"Patient" refers to the individual receiving care through ViviMED.`,
        `"Care Team" means the involved physicians, nurses, and coordination delivering services.`,
        `"Services" include at-home visits, virtual consultations, wellness checks, case coordination, and related offerings provided by ViviMED.`,
      ],
    },
    {
      subTitle: "6. Payments & Billing",
      paragraphs: [
        `"ViviMED" refers to our company, its staff, and authorized representatives.`,
        `"Sponsor" means the person, usually a family member living abroad, who sends and funds care for a patient in Cameroon.`,
        `"Patient" refers to the individual receiving care through ViviMED.`,
        `"Care Team" means the involved physicians, nurses, and coordination delivering services.`,
        `"Services" include at-home visits, virtual consultations, wellness checks, case coordination, and related offerings provided by ViviMED.`,
      ],
    },
    {
      subTitle: "7. User Responsibilities",
      paragraphs: [
        `"ViviMED" refers to our company, its staff, and authorized representatives.`,
        `"Sponsor" means the person, usually a family member living abroad, who sends and funds care for a patient in Cameroon.`,
        `"Patient" refers to the individual receiving care through ViviMED.`,
        `"Care Team" means the involved physicians, nurses, and coordination delivering services.`,
        `"Services" include at-home visits, virtual consultations, wellness checks, case coordination, and related offerings provided by ViviMED.`,
      ],
    },
    {
      subTitle: "8. Privacy & Data Protection",
      paragraphs: [
        `"ViviMED" refers to our company, its staff, and authorized representatives.`,
        `"Sponsor" means the person, usually a family member living abroad, who sends and funds care for a patient in Cameroon.`,
        `"Patient" refers to the individual receiving care through ViviMED.`,
        `"Care Team" means the involved physicians, nurses, and coordination delivering services.`,
        `"Services" include at-home visits, virtual consultations, wellness checks, case coordination, and related offerings provided by ViviMED.`,
      ],
    },
  ];

  return (
    <div className="privacy_container">
      <Header />

      {/* Hero Section */}
      <div className="privacy_hero_section">
        <div className="privacy_breadcrumb_wrapper">
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        <div className="privacy_hero_bg">
          <div className="privacy_hero_overlay" />
        </div>

        <div className="privacy_gradient_overlay" />

        <div className="privacy_hero_content">
          <p className="privacy_hero_subtitle">Privacy Policy</p>
          <h1 className="privacy_hero_title">Privacy Policy</h1>
        </div>
      </div>

      {/* Privacy Policy Content */}
      <div className="privacy_content">
        <div className="privacy_header">
          <p>Verimed</p>
          <p>January 12, 2024</p>
        </div>

        {sections.map((section, index) => (
          <div key={index} className="privacy_section">
            <p className="privacy_section_title">{section.subTitle}</p>

            {section.paragraphs &&
              section.paragraphs.map((para, idx) => (
                <p key={idx} className="privacy_section_paragraph">
                  {para}
                </p>
              ))}

            {section.list && (
              <ul className="privacy_section_list">
                {section.list.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            )}

            {section.nestedList &&
              section.nestedList.map((group, idx) => (
                <div key={idx} className="privacy_nested_group">
                  <p className="privacy_nested_heading">{group.heading}</p>
                  <ul className="privacy_nested_list">
                    {group.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
